import React from 'react'
import styled from 'styled-components'
import { FaReact, FaJs, FaNpm, FaHtml5, FaCss3Alt, FaNodeJs } from "react-icons/fa";
import { DiPhotoshop } from "react-icons/di";
import { MdCopyright } from "react-icons/md";

export default () => {
    const year = new Date().getFullYear();
    return (
        <Styles>
            <p><MdCopyright color="#ffffff" /> {year} with <FaReact color="#65E2FC" /> <FaNpm color="#CB0000" /> <FaNodeJs color="#66bb6a" /> <FaJs color="#E9D54D" /> <FaCss3Alt color="#28A4D9" /> <FaHtml5 color="#EA6228" /> <DiPhotoshop color="#32BFE9" /></p>
        </Styles>
    )
}

const Styles = styled.div`
text-align:center;
color:white;
background-color: #284040;
padding:0.5% 0 0.5% 0;
margin-top:10%;

p{
    margin-bottom:0px;
}

@media (min-width: 2200px) {
    p{
        font-size:110%;
    }
}

@media (max-width: 576px) {
    margin-top:5%;
    p{
        font-size:80%;
    }
}

`